<template>
  <div class="rep-examples">
    <div :class="unsecuredOnly ? 'rep-examples__centre' : 'rep-examples__left'">
      <h3>Unsecured representative example:</h3>
      <p>Unsecured Loans from £1,000 - £25,000.</p>
      <p>Loan terms from a minimum of 12 months to 60 months maximum.</p>
      <p>
        Rates from a minimum of 9.5% to a maximum of 89.9% APR. This has allowed
        us to help customers with a range of credit profiles.
      </p>
      <p>
        Lenders will offer loans of up to £25,000 subject to affordability.
      </p>
      <p>
        The % APR rate you will be offered is dependent on your personal
        circumstances.
      </p>
      <p>
        <strong>Representative 30.7% APR.</strong>
      </p>
      <p>
        Representative Example: Assumed borrowing of £7,500 over 36 months at a
        fixed rate of 30.7% per annum would result in a representative rate of
        30.7% APR, monthly repayments of £306.49 and a total amount repayable of
        £11,033.64.
      </p>
      <p>There are no fees for our service.</p>
    </div>
    <div class="rep-examples__right" v-if="!unsecuredOnly">
      <h3>Secured representative example:</h3>
      <p>
        Representative Example (Secured, if you choose to add fees to the loan):
        Assumed borrowing of £25,000 over 120 months, plus a broker fee of
        £2,500 and a lender fee of £250 would result in monthly repayments of
        £345.55, the borrowing rate is 8.6% (variable), the
        <strong>APRC is 11.7%</strong>
        (variable), total charge for credit £16,466.00 and the total amount
        payable £41,466.00. You can opt to pay the lender and/or broker fees
        upfront, your adviser will discuss these options with you.
      </p>
      <p>
        Think carefully before securing other debts against your home. Your home
        may be repossessed if you do not keep up repayments on a mortgage or any
        debt secured on it. All rates vary subject to loan amount, loan type and
        status. Repaying your debt over a longer period of time may increase the
        amount you pay.
      </p>
    </div>
    <div class="rep-examples__bottom">
      <h3>
        As a broker we will process the information you provide with our trusted
        panel of lenders to help get you a decision.
      </h3>
      <p>
        <strong>
          WARNING - LATE REPAYMENTS CAN CAUSE YOU SERIOUS MONEY PROBLEMS. FOR
          HELP, GO TO:
        </strong>
      </p>
      <a
        href="https://www.moneyadviceservice.org.uk/en"
        target="blank"
        rel="noopener"
      >
        <img src="@/assets/img/mas-logo.png" alt="Money Advice Service" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "RepRates",
  props: {
    unsecuredOnly: Boolean
  }
};
</script>
<style lang="scss" scoped>
.rep-examples {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 70px;

  @include breakpoint-max-($mobileScreen) {
    flex-direction: column;
  }

  strong {
    font-family: "gt_pressura_pro_m_bold";
  }

  &__left {
    flex: 1;
    margin-right: 20px;

    @include breakpoint-max-($mobileScreen) {
      margin: 0;
    }
  }

  &__right {
    flex: 1;
    margin-left: 20px;

    @include breakpoint-max-($mobileScreen) {
      margin: 20px 0 0;
    }
  }

  &__centre {
    flex: 0.5;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  &__bottom {
    flex-basis: 100%;
    margin-top: 70px;
    text-align: center;
  }

  img {
    max-width: 150px;
    margin: 10px auto 20px auto;
    display: block;
  }
}
</style>
